<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="PcDevice">
      <div class="outsideFrame" v-visible="show">
        <video loop="true" autoplay="autoplay" muted="true" id="myvideo">
          <source type="video/mp4" src="../../../public/LobbyVideo.mp4" />
        </video>

        <div class="AdLeft">
          <div
            id="carousel-ad"
            class="carousel slide carousel-fade"
            data-ride="carousel"
            data-interval="5000"
            data-pause="false"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/0A903D0D7D39A0A3C6123B726BA8A5D7"
                >
                  <img src="../../assets/images/carousel_BN/left_1.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/D3FB197A26E381AB89575A40670F7742"
                >
                  <img src="../../assets/images/carousel_BN/left_2.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/2C82EE6572236B82BE737F1E48470BF5"
                >
                  <img src="../../assets/images/carousel_BN/left_3.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/7A7C8F0CFA030482A143816F33F599FD"
                >
                  <img src="../../assets/images/carousel_BN/left_4.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/12B756B10CFE0D75011CA3A890CBB475"
                >
                  <img src="../../assets/images/carousel_BN/left_5.jpg" class="img-fluid" alt="..." />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="AdMiddleLeft">
          <div
            id="carousel-ad1"
            class="carousel slide carousel-fade"
            data-ride="carousel"
            data-interval="5000"
            data-pause="false"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/7A6391935CED5B1668E4519353256057"
                >
                  <img src="../../assets/images/carousel_BN/left_md_1.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item ">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/6B3AD53BC2C5172DF338644D3533825F"
                >
                  <img src="../../assets/images/carousel_BN/left_md_2.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/120716560FAB17F41172CFAB7AEDE80C"
                >
                  <img src="../../assets/images/carousel_BN/left_md_3.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/06D75103D18DDFCB9623BD6D5F6AD9F9"
                >
                  <img src="../../assets/images/carousel_BN/left_md_4.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/8554BC4D97588628E0A05C8711B61A12"
                >
                  <img src="../../assets/images/carousel_BN/left_md_5.jpg" class="img-fluid" alt="..." />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="AdMiddleRight">
          <div
            id="carousel-ad2"
            class="carousel slide carousel-fade"
            data-ride="carousel"
            data-interval="5000"
            data-pause="false"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/334703677F23352C24C982C3AA92191E"
                >
                  <img src="../../assets/images/carousel_BN/right_md_1.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/B34D779E4566022BED47A64DDC82C7B6"
                >
                  <img src="../../assets/images/carousel_BN/right_md_2.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/E3DED77673FF8056EE5D862F087F670C"
                >
                  <img src="../../assets/images/carousel_BN/right_md_3.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/631A3FD3A976A92CD461D46F1D896AC9"
                >
                  <img src="../../assets/images/carousel_BN/right_md_4.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/3BCA1512DD0EA083A3F40BF121B419C8"
                >
                  <img src="../../assets/images/carousel_BN/right_md_5.jpg" class="img-fluid" alt="..." />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="AdRight ">
          <div
            id="carousel-ad3"
            class="carousel slide carousel-fade"
            data-ride="carousel"
            data-interval="5000"
            data-pause="false"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/BFCCCC86EE40C82FC4AA7058FCB55695"
                >
                  <img src="../../assets/images/carousel_BN/right_1.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/111CD50DC1FCE41988B3E796CACFE5B0"
                >
                  <img src="../../assets/images/carousel_BN/right_2.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/645F99269153AB7A4A1F2303113453D3"
                >
                  <img src="../../assets/images/carousel_BN/right_3.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/1679883FE76E815BDF1A59E991F1235E"
                >
                  <img src="../../assets/images/carousel_BN/right_4.jpg" class="img-fluid" alt="..." />
                </a>
              </div>

              <div class="carousel-item">
                <a
                  target="_blank"
                  href="https://www.chanchao.com.tw/healthcos/onlineexpo/ExhibitorDetail/4A1243BED2EEB2A75289F2C665662B87"
                >
                  <img src="../../assets/images/carousel_BN/right_5.jpg" class="img-fluid" alt="..." />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="ProAdRight">
          <a href="https://expo.bioasiataiwan.com/en/" target="_blank">
            <img src="../../assets/images/MiddleSide_right.jpg" height="128px" alt="" @click="SaveEvent_log_right()" />
          </a>
          <span class="ProAdRight_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <div class="WebinarLeft">
          <a href="https://www.chanchao.com.tw/healthcos/en/eventSmile.asp" target="_blank">
            <img src="../../assets/images/MiddleSide_Left.jpg" class="img-fluid" alt="" @click="SaveEvent_log_left()" />
            <span class="WebinarLeft_dot"><i class="far fa-dot-circle"></i></span>
          </a>
        </div>

        <div class="HelpDesk" @click="openDeskModal">
          <span class="HelpDesk_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <div class="OfficialNewsDesk" @click="openNewsModal">
          <span class="OfficialNewsDesk_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <router-link :to="`/Exhibitors/Page=${1}`">
          <div class="ExhArea">
            <span class="ExhArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <router-link :to="`/PressReleases/Page=${1}`">
          <div class="NewsArea">
            <span class="NewsArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <router-link :to="`/Videos/Page=${1}`">
          <div class="VideoArea">
            <span class="VideoArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <div class="VidePlayer">
          <a
            href="https://www.youtube.com/watch?v=zpSFyD9ozg8"
            frameborder="0"
            allow="autoplay; encrypted-media"
            data-fancybox
            data-width="1280"
            data-height="720"
          >
            <img
              src="../../assets/images/Lobby_Video.jpg"
              width="316px"
              height="178px"
              alt=""
              @click="saveVideoLog()"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <!-- SHOWCASE SLIDER -->
      <section id="showcase" style="margin-top:70px">
        <img src="../../assets/images/MB_lobby.jpg" class="BannerHover img-fluid " alt="" />
      </section>

      <div class="d-flex justify-content-center align-items-center mt-3 mb-2">
        <div class="MbVidePlayer">
          <a
            href="https://www.youtube.com/watch?v=zpSFyD9ozg8"
            frameborder="0"
            allow="autoplay; encrypted-media"
            data-fancybox
            data-width="1280"
            data-height="720"
          >
            <img
              src="../../assets/images/Mb_Lobby_Video.jpg"
              class="BannerHover img-fluid px-3"
              alt=""
              @click="saveVideoLog()"
            />
          </a>
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-center">
        <a href="https://expo.bioasiataiwan.com/en/" target="_blank">
          <img
            src="../../assets/images/Mb_MiddleSide_right.jpg"
            class="img-fluid px-3"
            alt=""
            @click="SaveEvent_log_right()"
          />
        </a>
      </div>

      <div class="mt-3 mb-2 d-flex justify-content-center">
        <a href="https://www.chanchao.com.tw/healthcos/en/eventSmile.asp" target="_blank">
          <img
            src="../../assets/images/Mb_MiddleSide_Left.jpg"
            class="img-fluid px-3"
            alt=""
            @click="SaveEvent_log_left()"
          />
        </a>
      </div>

      <div class="text-center mb-3">
        <router-link :to="`/Exhibitors/Page=${1}`">
          <img src="../../assets/images/Mb_exhibition.jpg" class="img-fluid px-3 mt-2" alt="" />
        </router-link>
        <router-link :to="`/Videos/Page=${1}`">
          <img src="../../assets/images/Mb_video.jpg" class="img-fluid px-3 mt-3" alt="" />
        </router-link>

        <router-link :to="`/PressReleases/Page=${1}`">
          <img src="../../assets/images/Mb_pressrelease.jpg" class="img-fluid px-3 mt-3" alt="" />
        </router-link>

        <img src="../../assets/images/Mb_news.jpg" class="img-fluid px-3 mt-3" @click="openNewsModal" alt="" />
        <img src="../../assets/images/Mb_Information.jpg" class="img-fluid px-3 mt-3" @click="openDeskModal" alt="" />
      </div>
    </div>

    <div
      class="modal fade"
      id="HelpDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h2 class="modal-title font-weight-bold" id="exampleModalLongTitle">
              <img src="../../assets/images/title_profile.png" width="35px" class="mr-1 mb-1" alt="" />
              Information
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <div class="row ">
              <div class="col-md-9">
                <p class="mb-3" style="font-size:19px;font-weight:bold">
                  Asia Healthcare & Medical Cosmetology Expo
                </p>

                <p class="my-2">
                  Asia Healthcare & Medical Cosmetology Expo shows the whole industry chain of Nutraceutical and
                  Cosmetology, including materials, manufacturing, OEM/ODM, packaging and high-end products. Last year,
                  as the biggest in-person Healthcare & Medical Cosmetology trade show in Asia, more than 900 exhibitors
                  occupied more than 2,200 booths, attracting more than 120,000 visitors joined the show.
                </p>

                <p class="mb-2">
                  This year, Chan Chao provides you the best platform and opportunity to discover and tap new markets,
                  find new customers and partners, and grow your professional network without any space restriction.
                </p>

                <p>Welcome to Asia Healthcare & Medical Cosmetology Expo!</p>
              </div>

              <div class="col-md-3">
                <a href="https://chanchao.tw/136700" target="_blank">
                  <img
                    src="../../assets/images/Lobby_info_img.jpg"
                    class="EventBanner brightnessHover  img-fluid mt-3"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <p class="mt-4 mb-1" style="font-size:20px">You can find more information with following links:</p>
            <p>
              Official Website:
              <a class="text-primary" href="https://www.chanchao.com.tw/healthcos/en/" target="_blank"
                >https://www.chanchao.com.tw/healthcos/en/
              </a>
            </p>
            <p class="mb-2">
              Floor Plan of ONSITE Exhibition :
              <a class="text-primary" href="https://chanchao.tw/136700" target="_blank">https://chanchao.tw/136700</a>
            </p>

            <hr />

            <h4 class="my-4 font-weight-bold">Contact Information</h4>
            <div class="my-3">
              <img src="../../assets/images/Informationlogo.jpg" width="160px" alt="" />
              <p class="font-weight-bold my-2">Chan Chao International Co., Ltd</p>

              <p class="mt-2">Tel: +886-2-26596000</p>
              <p>Fax: +886-2-26597000</p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Sales Team</u>
              <p>Ms. Heidi Weng (ext.263)</p>

              <p>
                Email:
                <a class="text-primary" href="mailto:heidi@chanchao.com.tw">
                  heidi@chanchao.com.tw
                </a>
              </p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Marketing</u>
              <p>Ms. Lanny Chen (ext. 187)</p>
              <p>
                Email:
                <a class="text-primary" href="mailto:lanny@chanchao.com.tw">
                  lanny@chanchao.com.tw
                </a>
              </p>

              <p class="mt-2">Ms. Clair Yang (ext. 358)</p>
              <p>
                Email:
                <a class="text-primary" href="mailto:clair@chanchao.com.tw">
                  clair@chanchao.com.tw
                </a>
              </p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Customer Service</u>

              <p>
                Email:
                <a class="text-primary" href="mailto:CustomerService@chanchao.com.tw">
                  CustomerService@chanchao.com.tw
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="OfficialNewsDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h2 class="modal-title" id="exampleModalLongTitle">
              <img src="../../assets/images/title_news3.png" width="35px" class="mr-1 mb-2" alt="" />
              Official Press Release
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <div class="row align-items-center text-lg-left text-center mb-4" v-for="item in lastedNewList">
              <div class="col-lg-3 mb-3">
                <img
                  :src="`//www.chanchao.com.tw/exhibitionfiles/news/${item.NewsImg}`"
                  class="pointer img-fluid"
                  @click.prevent="goLastedNewsDetial(item.NewsNo)"
                />
              </div>
              <div class="col-lg-9">
                <p class="h5 title_fontStyle pointer" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  {{ item.Topic }}
                </p>
                <p class="pointer" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  {{ item.Brief }}
                </p>
                <p class="pointer" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  <i class="far fa-calendar mr-2"></i>
                  {{ item.PostDate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="NewsDetailDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h2 class="modal-title" id="exampleModalLongTitle">
              Official Press Release
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <div class="row text-lg-left text-center align-items-center">
              <div class="col-lg-3 mb-3">
                <img
                  :src="`//www.chanchao.com.tw/exhibitionfiles/news/${LastNewsInfo.NewsImg}`"
                  class="pointer img-fluid"
                />
              </div>
              <div class="col-lg-8">
                <h3>{{ LastNewsInfo.Topic }}</h3>

                <p>{{ LastNewsInfo.Brief }}</p>

                <p>Date: {{ LastNewsInfo.PostDate }}</p>
              </div>
            </div>

            <p>&zwnj;</p>

            <div class="DefaultStyleSheet" v-html="LastNewsInfo.Intro"></div>

            <p class="mt-4" v-if="LastNewsInfo.Url">
              Related Link : <a :href="LastNewsInfo.Url" target="_blank"> {{ LastNewsInfo.Url }}</a>
            </p>

            <div class="my-4">
              <div class="btn btn-primary px-4" @click="backtoNewsList">Back</div>
            </div>

            <p>&zwnj;</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 彈跳聊天室教學  -->

    <div
      class="modal fade"
      id="AlertChatRoom"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
      style="z-index:10000"
    >
      <div class="modal-dialog modal-dialog-centered " role="document">
        <form enctype="multipart/form-data" id="form">
          <div class="modal-content">
            <div class="modal-header modal-header-popup">
              <h2 class="modal-title mr-5" style="font-style: italic;">
                <img src="../../assets/images/idea.png" width="37px" class="mb-2" alt="" />
                <span class="ml-1">
                  Exhibition Tips
                </span>
              </h2>
            </div>
            <div class="modal-body modal-body-popup my-2" style="padding: 0rem 1rem 0rem 1rem;font-size:18px">
              <p class="mt-3">
                For more details of online exhibition, please click the upper-right
                <span
                  class="rounded-circle mx-1"
                  style="border:#6c757d solid 1px;padding:6px 10px;color: #6c757d;border-color: rgb(108, 117, 125);"
                >
                  <i class="fas fa-book" style="font-size:15px"></i>
                </span>
                icon of the screen.
              </p>
            </div>

            <div class="modal-footer modal-footer-popup">
              <button type="button" class="btn btn-primary py-2 px-5" @click.prevent="KnowTip()">
                OK
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        NewsNo: '',
        lastedNewList: [],
        LastNewsInfo: {},
        show: false,
        CSRF_Token: '',
      }
    },

    methods: {
      KnowTip() {
        localStorage.setItem('healthcos_notify_2024', 'AC20E266CA74B6E9D16B8D25A47752B2')
        $('#AlertChatRoom').modal('hide')
      },

      SaveEvent_log_right() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#bannerRight`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log_left() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#bannerLeft`
        // console.log(OpenEvent2)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      openDeskModal() {
        $('#HelpDesk').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenDesURL = `${NowPageUrl}#information`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenDesURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      openNewsModal() {
        $('#OfficialNewsDesk').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenNewsURL = `${NowPageUrl}#news`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenNewsURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      saveVideoLog() {
        const vm = this

        let NowPageUrl = location.href
        let OpenVideoURL = `${NowPageUrl}#video`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenVideoURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      backtoNewsList() {
        $('#NewsDetailDesk').modal('hide')
        $('#OfficialNewsDesk').modal('show')
      },

      goLastedNewsDetial(NewsNo) {
        $('#OfficialNewsDesk').modal('hide')

        const vm = this

        //取得最新消息詳細資料
        vm.$http
          .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNewsDetail/${vm.exhcode}/${NewsNo}?Lang=en`)
          .then((response) => {
            vm.LastNewsInfo = response.data
            $('#NewsDetailDesk').modal('show')

            this.$nextTick(() => {
              $('.DefaultStyleSheet br').remove() // 删除所有 <br> 标签
            })
          })
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'UnreadNum', 'exhcode']),
    },

    watch: {
      Roomvisible(v) {
        if (v && this.mobile) {
          document.getElementById('myDIV').classList.add('disable-pull')
        } else {
          document.getElementById('myDIV').classList.remove('disable-pull')
        }
      },

      UnreadNum(newValue) {
        if (this.UnreadNum !== newValue) {
          this.$store.dispatch('getUnread', newValue)
        }
      },
    },

    mounted() {
      let FirstEntry = localStorage.getItem('healthcos_notify_2024')
      if (FirstEntry !== 'AC20E266CA74B6E9D16B8D25A47752B2') {
        $('#AlertChatRoom').modal('show')
      }
    },

    created() {
      $('.modal').modal('hide')

      const vm = this

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      localStorage.setItem('bgcolor', 'red')

      $(function() {
        $('#carousel-ad').carousel({
          interval: 4000,
        })

        $('#carousel-ad1').carousel({
          interval: 4000,
        })

        $('#carousel-ad2').carousel({
          interval: 4000,
        })

        $('#carousel-ad3').carousel({
          interval: 4000,
        })
      })

      $(function() {
        $('#NewsDetailDesk').on('hide.bs.modal', function() {
          $('.modal-body').scrollTop(0)
        })
      })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          let windowWidth = window.innerWidth

          if (windowWidth > 1700) {
            $('html,body').scrollLeft(10)
          } else if (windowWidth < 1701 && windowWidth > 1610) {
            $('html,body').scrollLeft(120)
          } else if (windowWidth < 1611 && windowWidth > 1500) {
            $('html,body').scrollLeft(160)
          } else if (windowWidth < 1501 && windowWidth > 1400) {
            $('html,body').scrollLeft(245)
          } else if (windowWidth < 1401 && windowWidth > 1300) {
            $('html,body').scrollLeft(270)
          } else if (windowWidth < 1301 && windowWidth > 1200) {
            $('html,body').scrollLeft(320)
          } else if (windowWidth < 1201) {
            $('html,body').scrollLeft(430)
          }

          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
          // 視覺調整置中

          vm.$http
            .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNews/${vm.exhcode}?Type=Press&Lang=en`)
            .then((response) => {
              vm.lastedNewList = response.data
                .filter((item) => {
                  return item.archived == 1
                })
                .filter((item) => {
                  return item.PostDate.split('-')[0] > 2020
                })
              vm.show = true
            })
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .outsideFrame {
    position: relative;
    width: 1920px;
    height: 850px;
  }
  #myvideo {
    width: 1920px;
    height: 850px;
    left: 0;
    top: 0;
    margin-top: 88px;
    z-index: -99;
    overflow-x: scroll;
    overflow-y: auto;
  }

  .ProAdRight {
    position: absolute;
    width: 221px;
    -webkit-box-pack: center;
    top: 413px;
    right: 499px;
    z-index: 100;
  }

  .WebinarLeft {
    position: absolute;
    width: 221px;
    -webkit-box-pack: center;
    top: 414px;
    left: 497px;
    z-index: 100;
  }

  .HelpDesk {
    position: absolute;

    -webkit-box-pack: center;

    width: 300px;
    height: 122px;
    top: 773px;
    left: 320px;
    z-index: 100;
    cursor: pointer;
  }

  .OfficialNewsDesk {
    position: absolute;
    -webkit-box-pack: center;
    width: 83px;
    height: 187px;
    top: 691px;
    right: 446px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #c2cdc840;
      filter: brightness(10);
    }
  }

  .VidePlayer {
    position: absolute;
    width: 315px;
    height: 178px;
    top: 385px;
    left: 802px;
    -webkit-box-pack: center;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .MbVidePlayer {
    cursor: pointer;
  }

  .ExhArea {
    position: absolute;
    width: 227px;
    height: 122px;
    top: 585px;
    left: 846px;
    -webkit-box-pack: center;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #c2cdc840;
      filter: brightness(10);
    }
  }

  .VideoArea {
    position: absolute;
    width: 193px;
    height: 123px;
    -webkit-box-pack: center;
    top: 586px;
    left: 512px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #c2cdc840;
      filter: brightness(10);
    }
  }

  .NewsArea {
    position: absolute;
    -webkit-box-pack: center;
    width: 193px;
    height: 122px;
    top: 586px;
    left: 1213px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #c2cdc840;
      filter: brightness(10);
    }
  }

  // 廣告板位

  .AdLeft {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 93px;
    left: 334px;
    z-index: 100;
  }

  .AdRight {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 93px;
    right: 329px;
    z-index: 100;
  }

  .AdMiddleLeft {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 93px;
    left: 589px;
    z-index: 100;
  }

  .AdMiddleRight {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 93px;
    right: 588px;
    z-index: 100;
  }

  .carousel-inner {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
  }

  .carousel-item {
    height: 350px;
  }

  // 手機板banner

  .HomeTopicStyle {
    flex: 0 0 auto;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin: 24px 16px;
    background: center center / cover no-repeat #ada9ad;
  }

  // 閃耀點

  .ProAdRight_dot {
    position: absolute;
    left: 105px;
    top: -20px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .WebinarLeft_dot {
    position: absolute;
    left: 105px;
    top: -20px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .HelpDesk_dot {
    position: absolute;
    left: 153px;
    top: 0px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .OfficialNewsDesk_dot {
    position: absolute;
    left: 36px;
    top: 167px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .ExhArea_dot {
    position: absolute;
    left: 107px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .NewsArea_dot {
    position: absolute;
    left: 82px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .VideoArea_dot {
    position: absolute;
    left: 100px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  @keyframes flicker {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 1.2;
    }
  }

  .far {
    font-size: 13px;
  }

  .modal-body {
    height: 75vh;
    overflow-y: auto;
  }

  .modal-body-popup {
    height: 12vh;
    overflow-y: auto;
  }

  .modal-footer-popup {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0.45rem;
    border-top: 1px solid #cacacb;
    border-bottom-right-radius: calc(0.3rem - 1px);
    border-bottom-left-radius: calc(0.3rem - 1px);
  }

  .modal-header-popup {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 0.5rem 0.5rem;
    border-bottom: 1px solid #cacacb;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
  }
</style>
